// import React, { useState, history, useEffect } from "react";
// import axios from "axios";
// import SidebarEditUser from "../SidebarProfile";
// import { useHistory, Link } from "react-router-dom";
// import HeaderEtd from '../../../shared/components/HeaderEtd';
// import DataEnquiry from "../reportsEnquiry/DataEnquiryPortal";
// import Button from "@mui/material/Button";
// import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
// import { FaUserPlus, FaUserCog } from "react-icons/fa";
// import {
//   setAppIdSession,
//   setApplicantAss,
//   setRelativesAss,
//   setGurdianAss,
//   setAttachment,
//   setAppAction,
//   getSysId,
//   getUsername,
//   getStation,
//   url,
//   setOna,
//   getAppId,
// } from '../../../shared/utils/storage';
// //import "../printOut/assets/bill.css";
// //table
// import Box from "@mui/material/Box";
// import TextField from "@mui/material/TextField";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
// //end table

// function Administration() {
//   const [etd, setEtd] = useState({});
//   let appId = etd.AppId;
//   const [search, setSearch] = useState([]);
//   const [error, seterror] = useState();
//   const searchId = {
//     search: search,
//   };
//   /*========== clear field ============*/
//   const [inputValue, setInputValue] = useState("");
//   const handleUserInput = (e) => {
//     setInputValue(e.target.value);
//   };
//   const resetInputField = () => {
//     setInputValue("");
//   };
//   /*======= end of clear field ========*/

//   /*======= SELECT LOCATIONS ========*/
//   function getvillages(str) {
//     var xmlhttp = document.getElementById("BirthWardID").value;
//     let dropdown = document.getElementById("BirthVillage");
//     dropdown.length = 0;
//     let defaultOption = document.createElement("option");
//     defaultOption.text = "Choose Villages";

//     dropdown.add(defaultOption);
//     dropdown.selectedIndex = 0;

//     fetch("http://" + url() + "/etdapi/web/etd_get_villages", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ ward_id: xmlhttp }),
//     })
//       .then((res) => res.json())
//       .then((response) => {
//         var data = response.data;
//         let option;

//         for (var i = 0; i < data.length; i++) {
//           option = document.createElement("option");
//           option.text = data[i].villageName;
//           option.value = data[i].villageName;
//           dropdown.add(option);
//         }
//       });
//   }

//   function getwards(str) {
//     var xmlhttp = document.getElementById("DistrictID").value;
//     let dropdown = document.getElementById("BirthWardID");
//     dropdown.length = 0;

//     let defaultOption = document.createElement("option");
//     defaultOption.text = "Choose Wards";

//     dropdown.add(defaultOption);
//     dropdown.selectedIndex = 0;

//     fetch("http://" + url() + "/etdapi/web/etd_get_wards", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ district_id: xmlhttp }),
//     })
//       .then((res) => res.json())
//       .then((response) => {
//         var data = response.data;

//         let option;
//         for (var i = 0; i < data.length; i++) {
//           option = document.createElement("option");
//           option.text = data[i].WardName;
//           option.value = data[i].WardId;
//           dropdown.add(option);
//         }
//       });
//   }

//   function getdistrict(str) {
//     var xmlhttp = document.getElementById("mkoa").value;
//     let dropdown = document.getElementById("DistrictID");
//     dropdown.length = 0;

//     let defaultOption = document.createElement("option");
//     defaultOption.text = "Choose District";

//     dropdown.add(defaultOption);
//     dropdown.selectedIndex = 0;

//     fetch("http://" + url() + "/etdapi/web/etd_get_districts", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ region_id: xmlhttp }),
//     })
//       .then((res) => res.json())
//       .then((response) => {
//         var data = response.data;

//         let option;
//         for (var i = 0; i < data.length; i++) {
//           option = document.createElement("option");
//           option.text = data[i].DistrictName;
//           option.value = data[i].DistrictId;
//           dropdown.add(option);
//         }
//       });
//   }
  
//   function getregion(str) {
//     var xmlhttp = document.getElementById("eneo").value;
//     let dropdown = document.getElementById("mkoa");
//     dropdown.length = 0;

//     let defaultOption = document.createElement("option");
//     defaultOption.text = "Choose State";

//     dropdown.add(defaultOption);
//     dropdown.selectedIndex = 0;

//     fetch("http://" + url() + "/etdapi/web/etd_get_regions", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ region_id: xmlhttp }),
//     })
//       .then((res) => res.json())
//       .then((response) => {
//         var data = response.data;

//         let option;
//         for (var i = 0; i < data.length; i++) {
//           option = document.createElement("option");
//           option.text = data[i].RegionName;
//           option.value = data[i].regionId;
//           dropdown.add(option);
//         }
//       });
//   }

//   function getCountries(str) {
//     let dropdown = document.getElementById("BirthCountryID");
//     dropdown.length = 0;

//     let defaultOption = document.createElement("option");
//     defaultOption.text = "Choose State";

//     dropdown.add(defaultOption);
//     dropdown.selectedIndex = 0;

//     fetch("http://" + url() + "/etdapi/web/etd_get_countries", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//     })
//       .then((res) => res.json())
//       .then((response) => {
//         var data = response.data;

//         let option;
//         for (var i = 0; i < data.length; i++) {
//           option = document.createElement("option");
//           option.text = data[i].countryName;
//           option.value = data[i].countryId;
//           dropdown.add(option);
//         }
//       });
//   }
//   function getterritories() {
//     var xmlhttp = document.getElementById("BirthCountryID").value;
//     let dropdown = document.getElementById("eneo");
//     dropdown.length = 0;

//     let defaultOption = document.createElement("option");
//     defaultOption.text = "Choose State/Province";

//     dropdown.add(defaultOption);
//     dropdown.selectedIndex = 0;

//     fetch("http://" + url() + "/etdapi/web/etd_get_territories", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ region_id: xmlhttp }),
//     })
//       .then((res) => res.json())
//       .then((response) => {
//         var data = response.data;

//         let option;
//         for (var i = 0; i < data.length; i++) {
//           option = document.createElement("option");
//           option.text = data[i].TerritoryName;
//           option.value = data[i].territoryId;
//           dropdown.add(option);
//         }
//       });
//   }
//   /*======= END SELECT LOCATIONS ========*/

//   const [Administration, setAdministration] = useState({
//     PFNo: "",
//     FirstName: "",
//     MiddleName: "",
//     FamilyName: "",
//     BirthCountryID: "",
//     BirthTritoryID: "",
//     mkoa: "",
//     DistrictID: "",
//     BirthWardID: "",
//     BirthVillage: "",
//     EmailID: "",
//     PhoneNo: "",
//     LevelID: "",
//     ApplicationID: appId,
//   });

//   const handleChange = (e) => {
//     const data = { ...Administration };
//     data[e.target.name] = e.target.value;
//     setAdministration(data);
//     console.log(data);
//   };

//   return (
//     <>
//     <HeaderEtd />
//       <body className="">
//         <div className="wrapper">
//           <SidebarEditUser />
//           <div className="main-panel">
//             <div className="content4">
//               <div className="card-body">
//                 <h2 style={{ color: "#c2c2c2" }}>
//                   <i>Administration Module</i>
//                 </h2>
//                 <div className="card2">
//                   <div className="card-body">
//                     <div className="row">
//                       <div className="container">
//                         <Box textAlign="center">
//                           <Link to="#">
//                             <Button variant="contained" color="info">
//                               User Management
//                             </Button>
//                           </Link>
//                           &nbsp;&nbsp;
//                           <Link>
//                             <Button variant="outlined" color="warning" disabled>
//                               Application Management
//                             </Button>
//                           </Link>
//                           &nbsp;&nbsp;
//                           <Link>
//                             <Button variant="outlined" color="warning" disabled>
//                               Stock Management
//                             </Button>
//                           </Link>
//                         </Box>
//                         <hr />
//                         <br />
//                         <Tabs defaultIndex={2}>
//                           <TabList>
//                             <Tab disabled>
//                               &nbsp;
//                               <b style={{ fontSize: "17px" }}>&nbsp;Add User</b>
//                               &nbsp;
//                             </Tab>
//                             <Tab disabled>
//                               &nbsp;
//                               <b style={{ fontSize: "17px" }}>
//                                 &nbsp;View User
//                               </b>
//                               &nbsp;
//                             </Tab>
//                             <Tab>
//                               &nbsp;
//                               <b style={{ fontSize: "17px" }}>
//                                 &nbsp;Edit User Info.
//                               </b>
//                               &nbsp;
//                             </Tab>
//                           </TabList>
//                           <TabPanel>disabled</TabPanel>
//                           <TabPanel>disabled</TabPanel>
//                           <TabPanel>
//                             <div className="row">
//                               <div className="container">
//                                 <br />
//                                 <div className="col-md-12">
//                                   <Box
//                                     display="flex"
//                                     alignItems="center"
//                                     justifyContent="center"
//                                     sx={{
//                                       "& > :not(style)": {
//                                         m: 1,
//                                         width: "30ch",
//                                       },
//                                     }}
//                                   >
//                                     <TextField
//                                       id="demo-helper-text-misaligned-no-helper"
//                                       label="Personal-file-no. (PF)"
//                                     />
//                                     <TextField
//                                       id="demo-helper-text-misaligned-no-helper"
//                                       label="First-name"
//                                     />
//                                     <TextField
//                                       id="demo-helper-text-misaligned-no-helper"
//                                       label="Middle-name"
//                                     />
//                                     <TextField
//                                       id="demo-helper-text-misaligned-no-helper"
//                                       label="Surname"
//                                     />
//                                   </Box>
//                                 </div>
//                                 <br />
//                                 <div className="col-md-12">
//                                   <Box
//                                     display="flex"
//                                     alignItems="center"
//                                     justifyContent="center"
//                                     sx={{
//                                       "& > :not(style)": {
//                                         m: 1,
//                                         width: "30ch",
//                                       },
//                                     }}
//                                   >
//                                     <FormControl
//                                     // onFocus={(e) => getCountries(e.value)}
//                                     // onChange={(e) => getterritories(e.value)}
//                                     >
//                                       <InputLabel id="demo-simple-select-label">
//                                         Location
//                                       </InputLabel>
//                                       <Select
//                                         labelId="BirthCountryID"
//                                         id="BirthCountryID"
//                                         label="Location"
//                                         value={Administration.BirthCountryID}
//                                         onChange={(e) => handleChange(e)}
//                                       >
//                                         <MenuItem value="">
//                                           Choose Location
//                                         </MenuItem>
//                                       </Select>
//                                     </FormControl>

//                                     <FormControl>
//                                       <InputLabel id="demo-simple-select-label">
//                                         Region/State
//                                       </InputLabel>
//                                       <Select
//                                         labelId="demo-simple-select-label"
//                                         id="demo-simple-select"
//                                         // value={enquiry}
//                                         // onChange={handleChange}
//                                         label="Region/State"
//                                         value={Administration.BirthCountryID}
//                                         onChange={(e) => handleChange(e)}
//                                       >
//                                         <MenuItem value="">
//                                           Choose Region/State
//                                         </MenuItem>
//                                       </Select>
//                                     </FormControl>

//                                     <FormControl>
//                                       <InputLabel id="demo-simple-select-label">
//                                         Station
//                                       </InputLabel>
//                                       <Select
//                                         labelId="demo-simple-select-label"
//                                         id="demo-simple-select"
//                                         // value={enquiry}
//                                         // onChange={handleChange}
//                                         label="Station"
//                                         value={Administration.DistrictID}
//                                         onChange={(e) => handleChange(e)}
//                                       >
//                                         <MenuItem value="1">
//                                           Choose Station
//                                         </MenuItem>
//                                       </Select>
//                                     </FormControl>

//                                     <TextField
//                                       id="demo-helper-text-misaligned-no-helper"
//                                       label="Email-address"
//                                     />
//                                   </Box>
//                                 </div>
//                                 <br />
//                                 <div className="col-md-12">
//                                   <Box
//                                     display="flex"
//                                     alignItems="center"
//                                     justifyContent="center"
//                                     sx={{
//                                       "& > :not(style)": {
//                                         m: 1,
//                                         width: "30ch",
//                                       },
//                                     }}
//                                   >
//                                     <TextField
//                                       id="demo-helper-text-misaligned-no-helper"
//                                       label="Phone-number"
//                                     />

//                                     <FormControl>
//                                       <InputLabel id="demo-simple-select-label">
//                                         Level
//                                       </InputLabel>
//                                       <Select
//                                         labelId="demo-simple-select-label"
//                                         id="demo-simple-select"
//                                         // value={enquiry}
//                                         // onChange={handleChange}
//                                         label="Level"
//                                         onChange={(e) => handleChange(e)}
//                                       >
//                                         <MenuItem value="1">
//                                           Passport Counter Officer
//                                         </MenuItem>
//                                         <MenuItem value="2">
//                                           Visa Counter Officer
//                                         </MenuItem>
//                                         <MenuItem value="3">
//                                           Permit Counter Officer
//                                         </MenuItem>
//                                         <MenuItem value="4">
//                                           Citizenship Counter Officer
//                                         </MenuItem>
//                                         <MenuItem value="5">
//                                           Passport Officer
//                                         </MenuItem>
//                                         <MenuItem value="6">
//                                           Accountant
//                                         </MenuItem>
//                                         <MenuItem value="7">Printing</MenuItem>
//                                         <MenuItem value="8">BMC</MenuItem>
//                                       </Select>
//                                     </FormControl>
//                                   </Box>
//                                 </div>

//                                 <div className="col-md-12">
//                                   <Box
//                                     display="flex"
//                                     alignItems="center"
//                                     justifyContent="center"
//                                     sx={{
//                                       "& > :not(style)": {
//                                         m: 1,
//                                         width: "30ch",
//                                       },
//                                     }}
//                                   >
//                                     <Button
//                                       variant="contained"
//                                       color="info"
//                                       style={{
//                                         maxHeight: "40px",
//                                         minWidth: "267px",
//                                       }}
//                                     >
//                                       <FaUserCog />
//                                       &nbsp;Edit User
//                                     </Button>
//                                     <Button
//                                       variant="outlined"
//                                       color="warning"
//                                       style={{
//                                         maxHeight: "40px",
//                                         minWidth: "267px",
//                                       }}
//                                     >
//                                       Clear
//                                     </Button>
//                                   </Box>
//                                 </div>
//                               </div>
//                             </div>
//                           </TabPanel>
//                         </Tabs>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </body>
//     </>
//   );
// }

// export default Administration;

const EditUser = () => <div></div>;
export default EditUser;
